import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Img from '../../../Img' // task #67: canonical image component
import CtaV2 from '../../../CtaV2'

function ProductOffer({ title, subtitle, image, ctaTitle }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textAndCtas}>
          <div className={styles.textWrapper}>
            <div className={styles.title}>
              <SimpleBlockContent blocks={title} noSpace/>
            </div>
            <div className={styles.subtitle}>
              <SimpleBlockContent blocks={subtitle} noSpace/>
            </div>
          </div>
          {/* Overmind retirement (Phase D2): the former onClick dispatched
              setShowGlobalSaleOffer, a flag NO component ever read (the only
              reader — components/ShopItem's SaleOffer — is commented out), so the
              click was a no-op. Dropped with Overmind; the CTA is otherwise
              unchanged. */}
          <CtaV2
            title={ctaTitle}
            special
          />
        </div>
        <div className={styles.imageWrapper}>
          {/* task #67: descriptor via <Img> */}
          <Img
            image={image}
            alt={title}
            objectFit="contain"
          />
        </div>
      </div>
    </div>
  )
}

export default ProductOffer
